<template>
  <vx-card title="Upload Supplier Template">
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Supplier</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <multiselect v-if="!dataSelected"
          class="selectExample"
          v-model="supplier"
          :options="optionSupplier"
          :multiple="false"
          :allow-empty="true"
          :group-select="false"
          :max-height="160"
          :limit="4"
          placeholder=" Type to search"
          track-by="ID"
          label="Name"
          :disabled="false"
        >
          <template slot="singleLabel" slot-scope="dt">
            <span class="option__desc">
              <span class="option__title">{{ dt.option.Code }} - {{ dt.option.Name }}</span>
            </span>
          </template>

          <template slot="option" slot-scope="dt">
            <div class="option__desc">
              <span class="option__title">{{ dt.option.Code }} - {{ dt.option.Name }}</span>
            </div>
          </template>
        </multiselect>
        <vs-input v-else
            class="w-full "
            v-model="dataSelected.supplier_name"
            readonly=""
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>File (*.pdf)</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <input
          class="inputx"
          type="file"
          v-if="uploadReady"
          ref="file_attachment"
          name="file_attachment"
          accept=".pdf"
          required
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center"></div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-button class="ml-auto mt-2" v-on:click="handleSubmit"
        >Submit</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>
<script>
export default {
  components: {},
  props: {
    dataSelected: {
      type: [],
    },
  },
  data() {
    return {
      uploadReady: true,
      optionSupplier: [],
      supplier: null,
      status_submit: false,
      detail: false,
      detailShow: "vx-col md:w-1/2 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      selected: {},
    };
  },
  methods: {
    async handleSubmit() {
      this.status_submit = true;
      const formData = new FormData();
      if (this.dataSelected) {
        formData.append("action","update");
        formData.append("supplier_code", this.dataSelected.supplier_id);
        formData.append("template_id", this.dataSelected.id);
      }else if (this.supplier) {
          this.dataSelected = {
             id : null,
             supplier_id :this.supplier.ID,
             supplier_name :this.supplier.Name,
          }
          formData.append("supplier_code", this.supplier.ID);
          formData.append("action","create");
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Form Validation",
          text: "Supplier is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return
      }


      const files = this.$refs.file_attachment.files;
      if (files.length === 0) {
        this.$vs.notify({
          color: "danger",
          title: "Form Validation",
          text: "File  is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        this.$vs.loading.close();
        return
      }
      for (let i = 0; i < files.length; i++) {
        formData.append('documents', files[i]);
      }

      this.$vs.loading();
      try {
           await this.$http
              .post('/api/v1/ocr/templates/file',formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              })
              .then((resp) => {
                console.log("RESP",resp)
                  if (resp.success ) {

                    if (resp.data.length>0){
                      let template_id = resp.data[0].id
                      var message = "";
                      this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                      });
                      this.dataSelected["id"] = template_id
                    }else{
                      this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: "Failed upload data",
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle",
                      });
                    }
                  } else {
                      this.$vs.notify({
                          color: "danger",
                          title: "Error",
                          text: resp.message,
                          position: "top-right",
                          iconPack: "feather",
                          icon: "icon-x-circle",
                      });
                     this.$vs.loading.close();
                  }
                  this.$vs.loading.close();

                  this.supplier = null;
                  this.files = [];
                  this.status_submit = false;
                  this.$refs.file_attachment.value = '';

                  this.closeDetail();
              })
              .catch((error) => {
                  this.$vs.notify({
                      color: "danger",
                      title: "Error",
                      text: error,
                      position: "top-right",
                      iconPack: "feather",
                      icon: "icon-x-circle",
                  });
                  this.$vs.loading.close();
              });
      } catch (error) {
        console.error('Error uploading files:', error);
        this.$vs.loading.close();
      }
    },
    getOptionSupplier() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/master/suppliers", {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code == 200) {
            this.optionSupplier = resp.data.records;
          } else {
            this.$vs.notify({
              title: "Error",
              text: "Failed to get Supplier option",
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
          }
          this.$vs.loading.close();
        });
    },
    closeDetail() {
      this.detail = false;
      if (this.dataSelected){
        this.$emit("close-edit", this.dataSelected);
        return
      }
      this.$emit("close")
    },

  },
  mounted() {
      this.getOptionSupplier();

  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {

  },
};
</script>
<style scoped>
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.highlight > td {
  background-color: #d0cdf0;
}


.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
</style>
